module.exports = __webpack_public_path__ + "img/templateManage.0a4669ae.svg";